/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserHistory } from "history";
import React, { useEffect, useState } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { useIdleTimer } from 'react-idle-timer';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { PublisherApi, SessionApi } from './components/ApiUrl';
import App from './components/App';
import ApplicationModal from './components/ApplicationModal';
import dataFetcher from './components/dataFetcher';
import * as serviceWorker from './serviceWorker';
import IdleScreen from './view/MainBoard/Components/Idle';
import Sidebar from './view/MainBoard/Components/Sidebar';
import ScrollToTop from './view/ScrollToTop';
import { SessionPageHook } from './components/IndexPageHooks/SessionPageHook';
import { PublisherInfoHook } from './components/IndexPageHooks/PublisherInfoHook';

window.$apiUrl = process.env.REACT_APP_API_URL;
const fetchHolder = window.fetch;
const customFetch = (url, options) => {
  // console.log("fetch checker", options, url);
  if (!!options?.headers
  ["access-control-allow-origin"]) {
    delete options?.headers
    ["access-control-allow-origin"];
  }
  // Check if credentials are set, and if not, set them to "same-origin" or "include"
  options.credentials = process.env.NODE_ENV !== "production" ? "include" : "include" // You can set it to "include" if needed


  // Call the original fetch function with the modified options
  return fetchHolder(url, options);
};
window.fetch = customFetch;
const Index = () => {
  // const history = 
  const [menu, setMenuActive] = useState({ isActive: false });
  const { state: {
    publisherState,
    ...sessionState
  }, actions } = SessionPageHook();

  const { handleSessionTimeoutModal
    , logoutConfirmation
    , logoutSession } = actions;

  const resize = () => {
    let currentHideNav = (window.innerWidth >= 992);
    if (currentHideNav) {
      setMenuActive({ isActive: false });
    }
  }

  const toggleMenu = (val) => {
    if (val) {
      setMenuActive({ isActive: !menu.isActive });
    } else {
      setMenuActive({ isActive: false });
    }

  }

  useEffect(() => {
    resize()
    return function cleanup() {
      window.removeEventListener('resize', resize);
    }
  }, []);
  return (<>
    {sessionState.timeoutLogout && <IdleScreen />}
    <ScrollToTop />
    {sessionState.sessionKey === 'true' && <Sidebar toggleMenu={(val) => toggleMenu(val)} mobile_menu_toggle={menu.isActive} />}
    <App sessionKey={sessionState.sessionKey}
      logoutConfirmation={logoutConfirmation}
      publisherID={publisherState.publisherID}
      toggleMenu={toggleMenu}
      userName={publisherState.userName}
      publisherName={publisherState.publisherName}
      typeOfLogin={publisherState.typeOfLogin}/>
    <ApplicationModal
      logoutModal={sessionState.logoutModal}
      handleSessionTimeoutModal={handleSessionTimeoutModal}
      logoutSession={logoutSession}
      sessionTimeoutModal={sessionState.sessionTimeoutModal}
      logoutConfirmation={logoutConfirmation}/>
  </>);
}
const IndexRoot = () => <Router
  basename={'/depositapp'}
  history={createBrowserHistory()}>
  <Index />
</Router>
const appRoot = createRoot(document.getElementById('root'));
appRoot.render(<IndexRoot />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
